const updateBody = (body, title, policyBody, domainDatabaseId, destroyPolicy) => ({
  ...body,
  title: title.nextValue,
  body: policyBody.nextValue,
  domainDatabaseId: domainDatabaseId.nextValue,
  destroy: !!destroyPolicy,
})

function changePayload({command}, {title, destroyPolicy, domainDatabaseId, body: policyBody}) {
  const body = JSON.parse(command)
  const newCommand = updateBody(body, title, policyBody, domainDatabaseId, destroyPolicy)
  return {
    command: JSON.stringify(newCommand),
  }
}

export default changePayload
